import React from 'react';
import { Grid, Typography, Button, CardContent } from '@mui/material';
import Card from '../Card/Card';
import GridItem from '../Grid/GridItem';
import stock1 from '/assets/images/stock-photos/stock-1.jpg';

const ResourceSection = () => {
  return (
    <div className="py-5 bg-secondary my-5">
      <div className="container">
        <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
          <h1 className="display-3 mb-4 font-weight-bold">
            Learn more about computational thinking and programming!
          </h1>
          <p className="font-size-lg text-black-50">
            See the below resources for more detail
          </p>
        </div>
      </div>
      <div className="container-fluid">
        <div className="mt-4 text-center d-flex flex-row flex-wrap justify-content-center">
          <div>
            <div className="bg-white card card-box card-box-hover-rise px-2 pt-2 pb-3 m-3" title="Click below to see video">
              <b>Computational Thinking: What Is It? How Is It Used?</b>
              <iframe
                src='https://www.youtube.com/embed/qbnTZCj0ugI'
                allow='autoplay; encrypted-media'
                allowFullScreen={true}
                title='video'
              />
            </div>
          </div>
          <div>
            <div className="bg-white card card-box px-2 pt-2 pb-3 m-3" title="Click below to see video">
              <b>Computational Thinking for Children</b>
              <iframe
                src='https://www.youtube.com/embed/mUXo-S7gzds'
                allow='autoplay; encrypted-media'
                allowFullScreen={true}
                title='video'
              />
            </div>
          </div>
          <div>
            <div className="bg-white card card-box px-2 pt-2 pb-3 m-3" title="Click below to see video">
              <b>What is Computational Thinking?</b>
              <iframe
                src='https://www.youtube.com/embed/kdngEhA4I00'
                allow='autoplay; encrypted-media'
                allowFullScreen={true}
                title='video'
              />
            </div>
          </div>
          <div>
            <div className="card card-box px-2 pt-2 pb-3 m-3" title="Click below to see video">
              <b>Computational Thinking for a Computational World</b>
              <iframe
                src='https://www.youtube.com/embed/-nN6vyxa8lk'
                allow='autoplay; encrypted-media'
                allowFullScreen={true}
                title='video'
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
            <h1 className="display-3 mb-4 font-weight-bold">
              Some example activities for Getting started
            </h1>
            <p className="font-size-lg text-black-50">
              Activities
            </p>
          </div>
        </div>
        <div className="container-fluid">
          <Grid container spacing={4}>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <img alt="..." className="card-img-top" src={stock1} />
                  <Typography gutterBottom variant="h4" component="h4">
                    Activity 1
                  </Typography>
                  <Typography component="h5" variant="caption">
                    Level: Easy | Language: English | Subject: Computer Science | Class: VIII
                  </Typography>
                  <Typography component="p" variant="caption">
                    Description: To calculate the suitable structure circle/square inside square
                  </Typography>
                </CardContent>
                <div className="card-body text-center">
                  <Button size="small" variant="outlined" color="primary" className="mt-1">
                    Login to Start Activity
                  </Button>
                </div>
              </Card>
            </GridItem>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default ResourceSection;